<script setup>
import { watchEffect, ref } from 'vue'
import { useRoute } from 'vue-router'
import { getAnswerRecordDetail } from '@/api/admin'
import { formatDuringNoDecimal } from '@/utils/tools'

const props = defineProps({
  record: {
    type: Object,
    default: () => ({}),
  },
})

const route = useRoute()

const list = ref([])
// 获取详情
const fetchDetail = async () => {
  const res = await getAnswerRecordDetail({
    questionActiveKey: route.query.questionActiveKey,
    customerId: props.record.customerId,
  })

  if (res.ok) {
    list.value = res.data
  }
}

watchEffect(() => {
  fetchDetail()
})
</script>
<template>
  <div class="record-wrap">
    <p v-if="record.mobile" class="base-info-item">
      手机号：<span class="base-info-item-value">{{ record.mobile }}</span>
    </p>
    <p class="base-info-item">
      学校班级：<span class="base-info-item-value"
        >{{ record.firstName }} {{ record.secondName }}
        {{ record.thirdName }}</span
      >
    </p>
    <div class="ques-record-list">
      <div v-for="item in list" class="ques-record-item">
        <p class="ques-record-time">{{ item.submitTime }}</p>
        <p class="ques-record-time-used">
          用时: {{ formatDuringNoDecimal(item.longTime) }}
        </p>
        <!-- <p class="ques-record-detail-btn">查看详情</p> -->
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.record-wrap {
  .base-info-item {
    margin-bottom: 26px;
    font-size: 30px;
    color: #555555;
  }

  .ques-record-list {
    .ques-record-item {
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      padding: 30px 0;
      font-size: 26px;
      border-top: 1px solid rgba($color: #999999, $alpha: 0.2);

      .ques-record-time {
        color: #555555;
      }

      .ques-record-time-used {
        color: #555555;
      }

      .ques-record-detail-btn {
        color: #087efb;
      }
    }
  }
}
</style>
